<footer>
    <div class="container">
        <div class="row text-center">
            <div class="col-12">
                <ul class="footer-menu fs-12">
                    <li><a href="https://www.jidvei.ro/termeni-si-conditii">Termeni și condiții</a></li>
                    <li><a href="https://www.jidvei.ro/contact">Contact</a></li>
                </ul>
                <div class="text fs-12">Savurați cu moderație. Consumul excesiv de alcool este dăunător sănătății.</div>
                <div class="copyrights fs-12">© {{ currentYear }} Jidvei.</div>
            </div>
        </div>
    </div>
</footer>
